import { FormTextField } from '~/modules/common/components';
import { withReadOnlyNoValue } from './withReadOnlyNoValue';

export default withReadOnlyNoValue(FormTextField);
